/** Converte "YYYY-MM-DD HH:mm:ss" (API) para valor de input datetime-local (minutos). */
export function sqlDatetimeToDatetimeLocalValue(sql) {
  if (sql == null || sql === "") return "";
  const normalized = String(sql).trim().replace(" ", "T");
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

/**
 * Formata data/hora no fuso local do navegador (wall clock), sem deslocamento UTC.
 * Evita o erro de usar toISOString() em correções de trabalho.
 */
export function formatLocalDateTimeForApi(value) {
  if (value == null || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

/** Snapshot estável para comparar linha com baseline (mesmo formato que rowBaselines no painel). */
export function snapshotTrabalhoEdicao(a) {
  const start = a.startDateTime;
  const end = a.endDateTime;
  const startMs =
    start instanceof Date ? start.getTime() : start != null ? new Date(start).getTime() : null;
  let endMs = null;
  if (end instanceof Date) endMs = end.getTime();
  else if (end != null) {
    const t = new Date(end).getTime();
    endMs = Number.isNaN(t) ? null : t;
  }
  const teamIds = (a.team ?? [])
    .map((e) => e.id)
    .filter((id) => id != null)
    .sort((x, y) => x - y);
  return JSON.stringify({
    s: startMs,
    e: endMs,
    svc: a.serviceTypeId,
    mach: a.machineId,
    qp: Number(a.quantityProduced),
    qr: Number(a.quantityRefugo),
    qb: Number(a.quantityBorra),
    qg: Number(a.quantityGalho),
    team: teamIds,
  });
}

/**
 * Corpo parcial para POST trabalho/correcao/{id}: só chaves alteradas em relação ao baseline.
 */
export function buildTrabalhoCorrecaoPayload(activity, baselineJsonString) {
  const b = JSON.parse(baselineJsonString);
  const cur = JSON.parse(snapshotTrabalhoEdicao(activity));
  const patch = {};

  if (cur.s !== b.s) {
    patch.dtInicio = formatLocalDateTimeForApi(activity.startDateTime);
  }
  if (cur.e !== b.e) {
    patch.dtFim =
      activity.endDateTime == null || activity.endDateTime === ""
        ? null
        : formatLocalDateTimeForApi(activity.endDateTime);
  }
  if (cur.svc !== b.svc) {
    patch.servico_id = activity.serviceTypeId;
  }
  if (cur.mach !== b.mach) {
    patch.maquina_id = activity.machineId;
  }
  if (cur.qp !== b.qp) {
    patch.qtProduzida = activity.quantityProduced;
  }
  if (cur.qr !== b.qr) {
    patch.qtRefugo = activity.quantityRefugo;
  }
  if (cur.qb !== b.qb) {
    patch.qtBorra = activity.quantityBorra;
  }
  if (cur.qg !== b.qg) {
    patch.qtGalho = activity.quantityGalho;
  }
  if (JSON.stringify(cur.team) !== JSON.stringify(b.team)) {
    patch.equipe = (activity.team ?? []).map((ele) =>
      typeof ele.minimalToRemote === "function"
        ? ele.minimalToRemote()
        : { colaborador_id: ele.id }
    );
  }

  return patch;
}
